export default __webpack_public_path__ + "static/media/chapel.a021a355.jpg";